export const AVAILABLE = 'Available'
export const OCCUPIED = 'Occupied'
export const OFFLINE = 'Offline'

export default [
    AVAILABLE,
    OCCUPIED,
    OFFLINE
]

export const STATUS_GLYPHICONS = {
    [AVAILABLE]: 'ok-circle',
    [OCCUPIED]: 'user',
    [OFFLINE]: 'remove-circle'
}



// WEBPACK FOOTER //
// ./constants/status.js